import { initializeOverlay } from './modules/overlay.js';
import { initializeAccordion } from './modules/accordion.js';
import { initializeMvSlider } from './modules/mv-slider.js';
import { initializeNewsTabs } from './modules/news-tabs.js';
import { initializeSmoothScroll } from './modules/smooth-scroll.js';
import { initializeHeaderScroll } from './modules/header-scroll.js';
import { initializeHomeProductCard } from './modules/home-product-card.js';
import { initializePageLoaded } from './modules/page-loaded.js';
import { initializeHomeProductsReadmore } from './modules/home-products-readmore.js';

/**
 * メインJavaScript - 各モジュールの初期化
 */
document.addEventListener('DOMContentLoaded', () => {
  initializeOverlay();
  initializeAccordion();
  initializeMvSlider();
  initializeNewsTabs();
  initializeSmoothScroll();
  initializeHeaderScroll();
  initializeHomeProductCard();
  initializeHomeProductsReadmore();
  initializePageLoaded();
});
